// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('import', {
        url: '/import',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/import/import.tpl.html',
        controller: 'MainImportController as vm'
    });
}

// @ngInject
function MainImportController() {
    var vm = this;
}

angular.module('main.import', [
        'import.budgetimport'
    ])
    .config(stateConfig)
    .controller('MainImportController', MainImportController);

